import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    evenRow: {
      background: '#fff ',
      '&  td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
      '& td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
    },
    oddRow: {
      background: '#F5F8FA ',
      '&  td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
      '& td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
    },
    collapseEvenRow: {
      background: '#fff ',
    },
    collapseOddRow: {
      background: '#F5F8FA ',
    },
    contentBalloon: {
      width: '0px',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      left: -20,
    },
    contentDiplayNone: { display: 'none' },
    balloon: {
      display: 'grid',
      alignItems: 'center',
      width: 126,
      height: 51,
      background: '#FFFFFF',
      boxShadow:
        '0px 2px 0px rgba(0, 0, 0, 0.1), 0px -1px 3px rgba(0, 0, 0, 0.1)',
      borderRadius: 7,

      '& button': {
        display: 'flex',
        width: 130,
        height: 25,
        '& span': {
          width: 125,
          height: 21,
          fontSize: 10,
        },
      },
    },
    triangle: {
      position: 'relative',
      left: 1,
      top: 3,
    },
    tdWithBallon: {
      maxWidth: 69,
    },
    userName: {},
    tdName: { width: 384, maxWidth: 384 },
  }),
);

export default useStyles;
